module.exports = __webpack_public_path__ + "media/components/guide-page/static/icon-avatar-19b323c86a5ed79f834c055a05bf45a3.svg";